import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GameHistoryDetailsEffects } from './+state/game-history-details/game-history-details.effects';
import * as fromGameHistoryDetails from './+state/game-history-details/game-history-details.reducer';
import { GameHistoryEffects } from './+state/game-history/game-history.effects';
import { GameHistoryFacade } from './+state/game-history/game-history.facade';
import * as fromGameHistory from './+state/game-history/game-history.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromGameHistory.GAME_HISTORY_FEATURE_KEY,
      fromGameHistory.gameHistoryReducer,
    ),
    EffectsModule.forFeature([GameHistoryEffects, GameHistoryDetailsEffects]),
    StoreModule.forFeature(
      fromGameHistory.GAME_HISTORY_FEATURE_KEY,
      fromGameHistory.gameHistoryReducer,
    ),
    StoreModule.forFeature(
      fromGameHistoryDetails.GAME_HISTORY_DETAILS_FEATURE_KEY,
      fromGameHistoryDetails.reducer,
    ),
  ],
  providers: [GameHistoryFacade],
})
export class GameHistoryDataAccessModule {}
